import { Status, StatusLabel } from "@repo/ui/components/ui/status";
import type { StatusPickerOption } from "@/shared/status/status-picker-utils";

export const CATALOG_STATUS_OPTIONS: StatusPickerOption[] = [
  {
    value: "draft",
    label: "Draft",
    variant: "warning",
    displayLabel: (
      <Status variant="warning">
        <StatusLabel>Draft</StatusLabel>
      </Status>
    ),
  },
  {
    value: "active",
    label: "Active",
    variant: "success",
    displayLabel: (
      <Status variant="success">
        <StatusLabel>Active</StatusLabel>
      </Status>
    ),
  },
  {
    value: "retired",
    label: "Retired",
    variant: "error",
    displayLabel: (
      <Status variant="error">
        <StatusLabel>Retired</StatusLabel>
      </Status>
    ),
  },
];
